<div class="container-filter" matMenuContent (click)="$event.stopPropagation()">
  <div class="search-filter">
    <input
      class="search-filter__input"
      type="text"
      placeholder="Pesquisar por nome"
      (input)="onBuscaChange($event)"
    />
    <mat-icon class="search-filter__icon" svgIcon="magnify"></mat-icon>
  </div>

  @if (limiteAtingido()) {
    <span class="filter-limite-aviso">Limite de {{ maxSelection() }} usuários atingido.</span>
  }

  <div
    class="item-filter container-filter__padding"
    (scroll)="onScroll($event)"
  >
    <div class="lista">
      <div class="item" *ngFor="let usuario of filteredUsuariosComEstado()">
        <mat-checkbox
          color="primary"
          [ngModel]="usuario.checked"
          (ngModelChange)="onFiltroChange(usuario)"
          [disabled]="usuario.disabled"
          labelPosition="before"
        >
          <div class="container-nome">
            <img
              [src]="usuario.img"
              onError="this.src='assets/img/usuarioAnonimo.png'"
            />
            <span class="filter-text">{{ usuario.nome }}</span>
          </div></mat-checkbox
        >
      </div>
    </div>

    @if (carregando()) {
      <div class="filter-loading">Carregando...</div>
    }

    @if (!carregando() && !erro() && !filteredUsuariosComEstado().length) {
      <div class="filter-empty">Nenhum usuário encontrado.</div>
    }

    @if (erro()) {
      <div class="filter-empty">Falha ao carregar usuários.</div>
    }
  </div>
</div>
